import all from './all';
import items from './items';

export default {
  all,
  items,
};



// WEBPACK FOOTER //
// ./src/app/services/orderPickup/index.js